import Spk from '../views/spk/Spk'

const spk = [
    {
        path: '/spk',
        component: Spk,
        meta: { auth: false }
    },
]

export default spk